module.exports = __webpack_public_path__ + "assets/img/TrendingNow_word.c99eae69-ps.jpg";